/**
* If using Switch with async behaviour/network calls, use the 'disabled' prop with an 'isLoading' or 'isMutationInFlight' 
boolean to see a loading spinner on the switch while waiting for a response.
*/

import React, { useId } from 'react';
import classes from './Switch.module.scss';
import clsx from 'clsx';

export type Props = {
  className?: string;
  onToggle?: (value: boolean) => void;
  defaultValue?: boolean;
  checked?: boolean;
  isLoading?: boolean;
};

export default function Switch({ onToggle, className, defaultValue, checked, isLoading }: Props) {
  const id = useId();

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onToggle) {
      onToggle(event.target.checked);
    }
  }
  return (
    <div className={clsx(classes.wrapper, className)}>
      <input
        type="checkbox"
        className={classes.checkbox}
        id={id}
        onChange={handleChange}
        defaultChecked={defaultValue}
        checked={checked}
        disabled={isLoading}
      />
      <label className={clsx(classes.label, isLoading && classes.isLoading)} htmlFor={id}>
        toggle
      </label>
    </div>
  );
}
